// eslint-disable-next-line import/no-unresolved
import * as vueI18nOriginal from "vueI18nOriginal";

export const {
  DatetimeFormat,
  I18nInjectionKey,
  NumberFormat,
  Translation,
  VERSION,
  createI18n,
  useI18n,
  vTDirective
} = vueI18nOriginal;
